import React, { useState } from 'react';
import { ApiScreeningClearanceRuleTestResult } from '../../../api';
import ClearanceRuleRestInputPanel from './ClearanceRuleTestInputPanel';
import ClearanceRuleTestResults from './ClearanceRuleTestResults';
import SalvPage from '../../../common/SalvPage';

export type ScreeningClearanceRuleTestResult = {
  results: ApiScreeningClearanceRuleTestResult[];
};

export function ScreeningClearanceRulesSandbox() {
  const [results, setResults] = useState<ScreeningClearanceRuleTestResult>({
    results: [],
  });
  return (
    <SalvPage title={'Screening Clearance Rules Sandbox'}>
      <ClearanceRuleRestInputPanel setResults={setResults} />
      <ClearanceRuleTestResults results={results.results} />
    </SalvPage>
  );
}

export default ScreeningClearanceRulesSandbox;
